import { useEffect, useState } from 'react'
import { supabase } from '../supabaseClient'
import { useAuth } from '../context/AuthContext'
import ExerciseCard from '../components/ExerciseCard'
import { useNavigate } from 'react-router-dom'
import Navbar from '../components/Navbar'

export default function ExerciseLibrary() {
  const { profile } = useAuth()
  const [exercises, setExercises] = useState([])
  const [search, setSearch] = useState('')
  const [loading, setLoading] = useState(true)
  const navigate = useNavigate()

  useEffect(() => { fetchExercises() }, [])

  async function fetchExercises() {
    const { data } = await supabase
      .from('exercises')
      .select('*')
      .eq('clinic_id', profile.clinic_id)
      .order('created_at', { ascending: false })
    setExercises(data || [])
    setLoading(false)
  }

  async function handleDelete(id) {
    if (!confirm('Delete this exercise?')) return
    const { count } = await supabase
      .from('assignments')
      .select('id', { count: 'exact', head: true })
      .eq('exercise_id', id)
    if (count > 0) {
      alert('This exercise is assigned to ' + count + ' patient' + (count !== 1 ? 's' : '') + ' and cannot be deleted. Remove it from all patient programs first.')
      return
    }
    await supabase.from('exercises').delete().eq('id', id)
    setExercises(prev => prev.filter(e => e.id !== id))
  }

  const filtered = exercises.filter(ex => {
    const q = search.toLowerCase()
    return (
      ex.title?.toLowerCase().includes(q) ||
      ex.description?.toLowerCase().includes(q) ||
      ex.instructions?.toLowerCase().includes(q)
    )
  })

  return (
    <>
      <Navbar />
      <div className="page">
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '1.25rem' }}>
          <div>
            <span onClick={() => navigate('/clinician')} className="back-link" style={{ cursor: 'pointer' }}>← Dashboard</span>
            <h1>Exercise library</h1>
            <p>{exercises.length} exercise{exercises.length !== 1 ? 's' : ''}</p>
          </div>
          <button onClick={() => navigate('/clinician/exercises/new')}>+ New</button>
        </div>

        <div style={{ position: 'relative', marginBottom: '1.25rem' }}>
          <span style={{
            position: 'absolute', left: 14, top: '50%', transform: 'translateY(-50%)',
            color: 'var(--text-tertiary)', fontSize: 16, pointerEvents: 'none'
          }}>🔍</span>
          <input
            placeholder="Search exercises..."
            value={search}
            onChange={e => setSearch(e.target.value)}
            style={{ paddingLeft: 40 }}
          />
          {search && (
            <span
              onClick={() => setSearch('')}
              style={{
                position: 'absolute', right: 14, top: '50%', transform: 'translateY(-50%)',
                color: 'var(--text-tertiary)', cursor: 'pointer', fontSize: 18, lineHeight: 1
              }}
            >×</span>
          )}
        </div>

        {loading && <p>Loading...</p>}

        {!loading && exercises.length === 0 && (
          <div className="empty-state">
            <div className="empty-state-icon">🏋️</div>
            <h2 style={{ marginBottom: 8 }}>No exercises yet</h2>
            <p style={{ marginBottom: '1.5rem' }}>Add your first exercise to start building programs</p>
            <button onClick={() => navigate('/clinician/exercises/new')}>+ Add exercise</button>
          </div>
        )}

        {!loading && exercises.length > 0 && filtered.length === 0 && (
          <div className="empty-state">
            <div className="empty-state-icon">🔍</div>
            <h2 style={{ marginBottom: 8 }}>No results</h2>
            <p>No exercises match "{search}"</p>
          </div>
        )}

        {search && filtered.length > 0 && (
          <p style={{ marginBottom: '0.75rem', fontSize: 13 }}>
            {filtered.length} result{filtered.length !== 1 ? 's' : ''} for "{search}"
          </p>
        )}

        <div style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
          {filtered.map(ex => (
            <ExerciseCard key={ex.id} exercise={ex} onDelete={handleDelete} />
          ))}
        </div>
      </div>
    </>
  )
}
